import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  BasicTable,
  CardComponent,
  Columns,
  Dollar,
  OverviewCard,
  PageTitleAndSubTitle,
  PieChartWithoutCard,
  SvgEmployee,
  ToggleGroup,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { useStores } from '../../stores';
import OverviewCardTooltipContent from '../../_components/atoms/OverviewCardTooltipContent';
import { getCohortValue } from '../../core-utils/helper-utils/overviewCardHelper';
import {
  CostValues,
  MemberValues,
} from '../../core-utils/helper-utils/summaryReportHelper';
import { pageScrollDown } from '../SummaryPage';
import { collapsiblePatientTableHeaderStyles } from '../../core-utils/helper-utils/riskPatientDetailsHelper';
import { useNavigate } from 'react-router-dom';
import { PATIENT_DETAILS } from '../../core-utils/routes';
import properties from '../../core-utils/properties';
import axios from 'axios';
import { formatMembers } from '../../core-utils/helper-utils/riskProfileHelper';
import {
  numberToCurrencyFormatter,
  numFormatterWithSuffix,
} from '../../core-utils/helper-utils/helper';
import Loader from '../../_components/molecules/Loader';
import { scrollBarStyles } from '../../core-utils/messages/CommonConstants';
import moment from 'moment';
import glp1UtilizationMessages from '../../core-utils/messages/glp1UtilizationMessages';
import CustomColumnsTable from '../../_components/organisms/CustomColumnsTable';
import {
  columnsDropdownOptions,
  defaultGLPColumns,
  formatMembersListData,
  getColumns,
} from '../../core-utils/helper-utils/customColumnsHelper';
import { handleDownloadCSV } from '../../core-utils/helper-utils/downloadPdfHelper';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../_components/atoms/Snackbar';
import { getInfoIcon } from '../../core-utils/helper-utils/infoIconHelper';
import { observer } from 'mobx-react';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import DateFilter from '../../_components/molecules/DateFilter';
import useTotalEligible from '../../core-utils/custom-hooks/TotalEligible';
import AiSummaryCard from '../../_components/molecules/AiSummaryCard';
import allScreenLabel from '../../core-utils/messages/screenNamesForPrompts';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '1182px',
    padding: '40px 0px 66px 63px',
  },
  flex: {
    display: 'flex',
  },
  overviewCards: {
    display: 'flex',
    marginTop: '29px',
    gap: '24px',
  },
  loader: {
    minHeight: '500px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cards: {
    display: 'flex',
    alignItems: 'center',
    gap: '32px',
    marginTop: '32px',
    width: '1182px',
  },
  tableGrid: {
    maxHeight: '282px',
    overflowY: 'auto',
    ...scrollBarStyles,
  },
  customTable: {
    marginTop: '32px',
  },
});

const GLPDrug = observer(() => {
  const { classes } = useStyles();
  const employerGroupStore = useStores().employerGroupStore;
  const memberSummaryStore = useStores().memberSummaryStore;
  const quaterlyReportStore = useStores().quaterlyReportStore;
  const loginPageStore = useStores().loginPageStore;
  const cohortDetailsStore = useStores().cohortDetailsStore;
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quaterlyReportStore;

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();
  const abortController = new AbortController();

  const messages = glp1UtilizationMessages.GLP1_PAGE;

  const navigate = useNavigate();

  const {
    totalResults,
    memberIds: cohortMembers,
    isInitializing,
  } = useCohortOnPageLoad({
    fetchTotalResults: () => getGLP1DrugCohortMembers(),
    enabled:
      isPlanDatesFetched &&
      !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
  });

  const glp1DrugsColumns: Columns[] = [
    {
      name: 'Drug Name',
      align: 'left',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '',
    },
    {
      name: 'Members',
      align: 'left',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '',
    },
    {
      name: 'Total Cost',
      align: 'left',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '',
    },
    {
      name: 'Cost YAG',
      align: 'left',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '',
    },
  ];

  const defaultSelectedColumns = defaultGLPColumns;

  const previousYearCostSortFields = [
    'previousYearCost',
    'prevMedicalCost',
    'prevRxCost',
  ];
  const infoIcon = getInfoIcon(
    `Top 3 Diagnosis based on Total Cost.`,
    () => {},
    {
      display: 'flex',
      alignItems: 'center',
    },
  );

  //table pagination
  const [totalPages, setTotalPages] = useState(0);

  const [pageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);

  //loaders
  const [loading, setLoading] = useState<boolean>(false);
  const [tableLoading, setTableLoading] = useState<boolean>(false);

  const [clickedMember, setClickedMember] = useState<string>('');
  const [membersListData, setMembersListData] = useState<any[]>([]);
  const [memberIds, setMemberIds] = useState<string[]>([]);
  const [costValues, setCostValues] = useState<CostValues>({
    rx: '$0.00',
    medical: '$0.00',
    total: '$0.00',
  });
  const [memberValues, setMemberValues] = useState<MemberValues>({
    members: '0',
    employees: '0',
    dependents: '0',
  });
  const [totalCohortCost, setTotalCohortCost] = useState<number>(0);
  const [pmpm, setPmpm] = useState<string>('$0.00');
  const [glp1DrugsData, setGlp1DrugsData] = useState<any[]>([]);
  const [selectedToggle, setSelectedToggle] = useState<'left' | 'right'>(
    'left',
  );
  const [diabeticData, setDiabeticData] = useState<any>({});
  const [nonDiabeticData, setNonDiabeticData] = useState<any>({});
  const [sortField, setSortField] = useState<string>('totalCost');
  const [sortOrder, setSortOrder] = useState<number>(-1);
  const [tableColumns, setTableColumns] = useState<Columns[]>(
    getColumns(defaultSelectedColumns, infoIcon),
  );
  const [selectedColumns, setSelectedColumns] = useState<string[]>(
    defaultSelectedColumns,
  );
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });
  const [aiLoading, setAiLoading] = useState<boolean>(false);
  const screenName = allScreenLabel;
  const [activeAskAi, setActiveAskAi] = useState<boolean>(false);
  const [aiSummaryData, setAiSummaryData] = useState<
    { title: string; description: string }[]
  >([]);

  const { open, openModal, closeModal, isEditMode } = useCohortModal();

  //Functions

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const handlePageChange = (event: ChangeEvent<unknown>, page: number) => {
    setPageNumber(page);
  };

  const handleMemberClick = (value: string) => {
    setClickedMember(value);
  };

  const membersListRequestBody = {
    eg_nid: employerGroupStore.employerGroupResponseData.eg_nid,
    startYear: moment(
      aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
      'YYYY-MM-DD',
    ).year(),
    member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
    pageNumber: pageNumber - 1,
    pageSize: pageSize,
    sortField: sortField,
    sortOrder: sortOrder,
    category: 'chronic',
    startDate:
      aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
    endDate: aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
    max_claim_date: employerGroupStore.employerGroupResponseData.max_claim_date,
    columnList: selectedColumns,
    showAll: previousYearCostSortFields?.includes(sortField),
    drugType: 'Glucagon-like Peptide-1 (glp-1) Analogues',
    diagnosis_count: 3,
    diagnosis_sort_field: 'totalPaid',
  };

  const handleChangeColumns = () => {
    setTableColumns(getColumns(selectedColumns, infoIcon));
    getRiskMembersList();
  };

  const handleSort = (event: any, column: any, item: any) => {
    const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
    const { sortColumnName } = column;
    if (!sortColumnName) {
      return;
    }

    setSortField(sortColumnName);
    setSortOrder(sortOrder);
  };

  const handleExportCSV = () => {
    handleDownloadCSV(
      properties.aiqBaseUrl + properties.membersList + '/csv',
      { ...membersListRequestBody, showAll: true },
      `GLP-drugs.csv`,
      handleOpenSnackBar,
    );
  };
  const handleAskAi = () => {
    setActiveAskAi(true);
    getAiSummarizedData();
  };

  //APIs
  const {
    overAllEnrolled,
    overallTotalCost,
    getTotalEligible,
  } = useTotalEligible(
    aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
    aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
    employerGroupStore,
    abortController.signal,
  );

  const getGLP1DrugCohortMembers = async (): Promise<{
    noOfMemberIds: number;
    member_unique_ids: string[];
  }> => {
    const response = await axios.post(
      properties.aiqBaseUrl +
        properties.utilizationBaseUrl +
        properties.getGLP1DrugCohortMembers,
      {
        ...payload,
        claim_id_list: [],
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
      },
      { signal: abortController.signal },
    );

    return response.data.data;
  };

  const getGLPSummary = async () => {
    const response = await axios.post(
      properties.aiqBaseUrl +
        properties.utilizationBaseUrl +
        properties.glpDrug,
      {
        ...payload,
        claim_id_list: [],
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
      },
      { signal: abortController.signal },
    );
    return response.data;
  };

  const getGLPDrugsDetails = async () => {
    const response = await axios.post(
      properties.aiqBaseUrl +
        properties.utilizationBaseUrl +
        properties.glp1DrugsDetails,
      {
        ...payload,
        claim_id_list: [],
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
      },
      { signal: abortController.signal },
    );
    return response.data;
  };

  const getGLPDrugsDetailsByChronic = async () => {
    const response = await axios.post(
      properties.aiqBaseUrl +
        properties.utilizationBaseUrl +
        properties.glp1DrugsClassification,
      {
        ...payload,
        claim_id_list: [],
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
      },
      { signal: abortController.signal },
    );
    return response.data;
  };

  const getMemberClaims = async (memberId: string, costliest_drugs: any[]) => {
    return await axios
      .post(
        properties.aiqBaseUrl +
          properties.membersBaseUrl +
          properties.memberDetails,
        {
          eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
          paidStartDate,
          paidEndDate,
          incurredStartDate,
          incurredEndDate,
          aggregationParameter,
          member_unique_id: [memberId],
          claim_id_list: [],
          drugNames: costliest_drugs?.map((item) => item.drug_name),
        },
      )
      .then((response) => response.data);
  };

  const getRiskMembersList = async () => {
    setTableLoading(true);
    const response = await axios.post(
      properties.aiqBaseUrl + properties.membersList,
      membersListRequestBody,
    );

    if (response?.status === 200) {
      const updatedData = await Promise.all(
        response?.data?.data?.memberList?.map(async (item: any) => {
          const memberClaimsData = await getMemberClaims(
            item['Member ID'],
            item['Costliest Drugs'],
          );
          return {
            ...item,
            claimData: memberClaimsData?.data,
          };
        }),
      );

      setMembersListData(formatMembersListData(updatedData, selectedColumns));
      setTableLoading(false);
    }
  };

  const getRiskMembersListForAI = async () => {
    const response = await axios.post(
      properties.aiqBaseUrl + properties.membersList,
      {
        ...membersListRequestBody,
        showAll: true,
      },
    );

    return response?.data?.data?.memberList ?? [];
  };
  const getAiSummarizedData = async () => {
    try {
      setAiLoading(true);

      // only fetch paginated dependent API
      const membersList = await getRiskMembersListForAI();

      const apiResponses = {
        title_1: {
          totalMembers: memberValues?.members,
          employees: memberValues?.employees,
          dependents: memberValues?.dependents,
          rxCost: costValues?.rx,
          medicalCost: costValues?.medical,
          totalCost: costValues?.total,
          pmpm: pmpm,
        },

        title_2: glp1DrugsData?.map((item: any) => ({
          drugName: item?.[0],
          members: item?.[1],
          totalCost: item?.[2],
          costYAG: item?.[3],
        })),

        title_3: {
          diabeticMembers: diabeticData?.members,
          diabeticCost: diabeticData?.totalCost,
          nonDiabeticMembers: nonDiabeticData?.members,
          nonDiabeticCost: nonDiabeticData?.totalCost,
        },

        title_4: membersList?.map((item: any) => ({
          memberId: item?.['Member ID'],
          totalCost: item?.['Total Cost'],
          diagnosis: item?.['Top Diagnosis'],
          costliestDrugs: item?.['Costliest Drugs'],
        })),
      };
      let resultArray = []; // ✅ default fallback

      try {
        const response = await axios.post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.getAiSummary,
          {
            screenName: screenName.GLP_DRUGS,
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
            incurredStartDate,
            incurredEndDate,
            paidStartDate,
            paidEndDate,
            apiData: apiResponses,
          },
        );

        // ✅ Safe extraction
        resultArray = response?.data?.data?.data?.result || [];
        setAiSummaryData(Array.isArray(resultArray) ? resultArray : []);
      } catch (apiError) {
         
        console.error('AI Summary API failed:', apiError);
        // ✅ Optional: show user-friendly message
        handleOpenSnackBar('Failed to load summary', 'warning', 4000);
        setAiSummaryData([]);
      }
    } catch (error: any) {
      console.error(error);
    } finally {
      setAiLoading(false);
    }
  };

  const apiCalls = async () => {
    try {
      setLoading(true);

      const response = await getGLPSummary();
      const data = response?.data;

      if (data) {
        const {
          member_list,
          rxPaid,
          medicalPaid,
          relationship,
          pmpm,
          totalPaid,
        } = data;

        setMemberIds(member_list);
        setTotalPages(Math.ceil((member_list?.length || 0) / pageSize));

        setCostValues({
          rx: numberToCurrencyFormatter(rxPaid, true),
          medical: numberToCurrencyFormatter(medicalPaid, true),
          total: numberToCurrencyFormatter(totalPaid, true),
        });
        setTotalCohortCost(totalPaid);
        setPmpm(numberToCurrencyFormatter(pmpm, true));

        setMemberValues(formatMembers(relationship));
      }

      const res = await getGLPDrugsDetails();
      const glp1DrugsTableData: any[] = [];
      res?.data?.forEach((item: any) => {
        const eachRow: any[] = [];
        eachRow[0] = item?.drug_name;
        eachRow[1] = item?.members;
        eachRow[2] = numberToCurrencyFormatter(item?.totalCost, true) ?? '-';
        eachRow[3] = `${item?.cost_change_percent?.toFixed(2)}%`;
        glp1DrugsTableData.push(eachRow);
      });
      setGlp1DrugsData(glp1DrugsTableData);

      const responseData = await getGLPDrugsDetailsByChronic();
      const diabeticData = responseData?.data?.find(
        (item: any) => item?.chronicDisease === 'Diabetes',
      );
      const nonDiabeticData = responseData?.data?.find(
        (item: any) => item?.chronicDisease === 'Non-Diabetic',
      );
      setDiabeticData(diabeticData);
      setNonDiabeticData(nonDiabeticData);

      await getTotalEligible();
    } catch (error) {
       
      console.error('Error fetching GLP details:', error);
    } finally {
      setLoading(false);
    }
  };

  //useEffects

  useEffect(() => {
    if (isInitializing) {
      return;
    }
    apiCalls();

    return () => {
      abortController.abort();
    };
  }, [
    isInitializing,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    cohortDetailsStore.conditionsDetails,
  ]);

  useEffect(() => {
    memberIds?.length && getRiskMembersList();
  }, [memberIds, pageNumber, sortField, sortOrder]);

  useEffect(() => {
    if (clickedMember) {
      memberSummaryStore.setPathDetails([
        [
          'text',
          'GLP-1 Drug Utilization',
          {
            color: patientAccessTheme.palette.primary[500],
            fontWeight: 500,
          },
        ],
      ]);
      navigate(PATIENT_DETAILS, { state: { memberId: clickedMember } });
    }
  }, [clickedMember]);

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);
  //components
  const OverviewCards = () => {
    return (
      <Grid className={classes.overviewCards}>
        <OverviewCardTooltipContent
          type={'member'}
          cohortMemberValues={memberValues}
          totalMemberValues={{
            dependents: overAllEnrolled.dependents,
            employees: overAllEnrolled.employees,
            members: overAllEnrolled.totalCount,
          }}
          overviewCard={
            <OverviewCard
              title={messages.CARDS.MEMBERS}
              value={getCohortValue(
                memberValues?.members,
                overAllEnrolled.totalCount,
              )}
              rootStyles={{
                width: '176px',
                fontWeight: 600,
                fontSize: ' 24px',
              }}
            />
          }
        />
        <OverviewCardTooltipContent
          type={'cost'}
          cohortCostValues={costValues}
          totalCostValues={{
            medical: overallTotalCost.totalMedical,
            rx: overallTotalCost.totalRx,
            total: overallTotalCost.totalCost,
          }}
          overviewCard={
            <OverviewCard
              title={messages.CARDS.TOTAL_COST}
              value={getCohortValue(
                `$${numFormatterWithSuffix(totalCohortCost, 2)}`,
                overallTotalCost.totalCost,
              )}
              rootStyles={{
                width: '216px',
              }}
              labelsMinWidth="72px"
            />
          }
        />
        <OverviewCard
          title={messages.CARDS.PMPM}
          value={pmpm}
          rootStyles={{
            width: '176px',
            height: '100px',
          }}
        />
      </Grid>
    );
  };

  return isPlanDatesLoading || loading || isInitializing ? (
    <Loader />
  ) : (
    <Grid className={classes.root}>
      <PageTitleAndSubTitle
        title={messages.TITLE}
        chip={
          <Grid className={classes.flex}>
            <Typography
              fontSize="17px"
              lineHeight="21px"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
              fontType="semiBold"
              margin="2px 8px 0px 0px"
            >
              for
            </Typography>
            <DateFilter />
          </Grid>
        }
        // subTitle={messages.SUB_TITLE}
        subTitle={
          <>
            Analyzes usage, spending, and member demographics for GLP drugs,
            identifying whether they are used by <br /> members with or without
            a diabetes diagnosis.
          </>
        }
        subTitleStyles={{ width: '100%' }}
        showAskAi={true}
        askAiAction={handleAskAi}
        showQueryDataButton={checkUserAccess(
          UserAccessConstants.COHORT_DETAILS,
          loginPageStore.userResponse.role.name,
          loginPageStore.userFeatures,
        )}
        queryButtonText={
          cohortDetailsStore.cohortDetailsList?.length > 0 &&
          cohortDetailsStore.cohortDetailsList[0].category !== ''
            ? 'Edit Cohort'
            : 'Add Cohort'
        }
        queryDataAction={() => {
          if (
            checkUserAccess(
              UserAccessConstants.COHORT_DETAILS,
              loginPageStore.userResponse.role.name,
              loginPageStore.userFeatures,
            )
          ) {
            openModal();
          }
        }}
      />
      <CohortFilterBar />
      <OverviewCards />
      <Grid className={classes.cards}>
        <CardComponent
          title={messages.DURGS_TABLE.TITLE}
          subTitle={messages.DURGS_TABLE.SUB_TITLE}
          height="390px"
          width="620px"
          body={
            <Grid className={classes.tableGrid}>
              <BasicTable
                displayType="row"
                columns={glp1DrugsColumns}
                rowsData={glp1DrugsData}
                isFullTable
              />
            </Grid>
          }
        />
        <CardComponent
          title={messages.PIE_CHART.TITLE}
          subTitle={messages.PIE_CHART.SUB_TITLE}
          height="390px"
          width="530px"
          topRightItem={
            <ToggleGroup
              leftValue={'Cost'}
              rightValue={'Members'}
              leftIcon={<Dollar style={{ height: '18px', width: '18px' }} />}
              rightIcon={
                <SvgEmployee
                  style={{
                    height: '16px',
                    width: '16px',
                  }}
                />
              }
              setSelectedToggle={setSelectedToggle}
              toggleLeftSideStyles={{
                border: 'none',
                borderRight:
                  '1px solid ' + patientAccessTheme.palette.grey[300],
                width: '72px',
              }}
              toggleRightSideStyles={{
                border: 'none',
                borderLeft: '1px solid ' + patientAccessTheme.palette.grey[300],
                width: '92px',
              }}
            />
          }
          body={
            <PieChartWithoutCard
              data={[
                {
                  value:
                    selectedToggle === 'left'
                      ? diabeticData?.totalCost
                      : diabeticData?.members,
                  color: patientAccessTheme.palette.primary[100],
                },
                {
                  value:
                    selectedToggle === 'left'
                      ? nonDiabeticData?.totalCost
                      : nonDiabeticData?.members,
                  color: patientAccessTheme.palette.primary[300],
                },
              ]}
              showLegend={true}
              showValues={true}
              addPrefix={selectedToggle === 'left'}
              chartHeight="300"
              chartWidth="400"
              legend={[
                {
                  label: 'Diabetic',
                  color: patientAccessTheme.palette.primary[100],
                  // value: '$10,000.00',
                },
                {
                  label: 'Non-Diabetic',
                  color: patientAccessTheme.palette.primary[300],
                  // value: '$12,000.00',
                },
              ]}
            />
          }
        />
      </Grid>

      <Grid id="member-details" className={classes.customTable}>
        <CustomColumnsTable
          title={
            <Grid className={classes.flex}>
              <Typography
                fontSize="16px"
                lineHeight="24px"
                textColor={patientAccessTheme.palette.text.highemphasis}
                fontType="semiBold"
                margin="2px 8px 0px 0px"
              >
                {messages.MEMBERS_TABLE.TITLE}
              </Typography>
            </Grid>
          }
          subTitle={messages.MEMBERS_TABLE.SUB_TITLE}
          options={columnsDropdownOptions}
          mandateOptions={['Member ID']}
          selectedItems={selectedColumns}
          setSelectedItems={setSelectedColumns}
          handleChangeColumns={handleChangeColumns}
          handleExport={handleExportCSV}
          columns={tableColumns}
          rowsData={membersListData}
          tableLoading={tableLoading}
          handleMemberClick={handleMemberClick}
          handleSort={handleSort}
          totalPages={totalPages}
          handlePageChange={handlePageChange}
          pageNumber={pageNumber}
        />
      </Grid>
      <div id="scroll-top-element" />
      {pageScrollDown('scroll-top-element')}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <CohortDetailsModal
        open={open}
        handleClose={closeModal}
        totalResults={totalResults}
        isEditMode={isEditMode}
        existingMemberUniqueIds={cohortMembers}
      />
      <AiSummaryCard
        open={activeAskAi}
        onClose={() => {
          setActiveAskAi(false);
          setAiSummaryData([]);
        }}
        aiSummaryData={aiSummaryData}
        loading={aiLoading}
      />
    </Grid>
  );
});

export default GLPDrug;
